import styled from "styled-components";
import Text from "common/Typography/Text";
import { CSSProperties, ReactNode } from "react";

interface DividerProps {
  text: ReactNode;
  style?: CSSProperties;
  textStyle?: CSSProperties;
}

const Divider = ({ text, style, textStyle }: DividerProps) => {
  return (
    <Wrapper style={style}>
      <Line />
      <DividerText type="secondary" style={textStyle}>
        {text}
      </DividerText>
      <Line />
    </Wrapper>
  );
};

export default Divider;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const DividerText = styled(Text)`
  padding: 0 10px;
`;
const Line = styled.div`
  flex: 1;
  border-top: ${(p) => p.theme.borders.medium};
`;
